module.exports = __webpack_public_path__ + "img/tron (74).a12fe7ee.jpg";